"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hashtagRegex = void 0;
const extractAllPatterns_1 = __importDefault(require("./extractAllPatterns"));
exports.hashtagRegex = /#[À-žA-Za-z0-9_]+/gm;
exports.default = (input, dontReplaceHash = false) => {
    return (0, extractAllPatterns_1.default)(exports.hashtagRegex, input, dontReplaceHash ?
        undefined :
        (match) => match.replace('#', ''));
};
